export default __webpack_public_path__ + "static/media/tower_logo_black-120.b0dfe963.webp";